import { useSWRFetch } from '@hooks/useSWRFetch';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import { buildArtistUriFromId, isEmptyString } from '@helpers/utils';
import { ArtistDetails, ArtistInfoResult } from './types';

export const useArtistInfo = (
  artistUri: string = '',
  page: number = 1,
  limit: number = 10,
): ArtistInfoResult => {
  const searchParams = new URLSearchParams();
  const offset = (page - 1) * limit;

  searchParams.append('albumsPagination.offset', offset.toString());
  searchParams.append('albumsPagination.limit', limit.toString());

  const requestObject = {
    url: `v2/artist/${buildArtistUriFromId(artistUri)}?${new URLSearchParams(
      searchParams,
    )}`,
  };

  const canRequest = !isEmptyString(artistUri);

  const { data, error, isValidating, isLoading, status, mutate } =
    useSWRFetch<ArtistDetails>(canRequest ? requestObject : null, {
      dedupingInterval: TEN_MINUTES_IN_MS,
      revalidateOnFocus: false,
    });

  return {
    data: {
      artistInfo: data,
    },
    error,
    isValidating,
    isLoading,
    status,
    mutate,
  };
};
